import axios from 'axios'
import qs from 'qs'
axios.defaults.baseURL = 'http://api1.home.didigo.es/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
//axios.defaults.withCredentials =true;
axios.defaults.timeout = 60000 //1分种的超时请求时间

// axios请求拦截器
axios.interceptors.response.use((res) => {
    if (res.status) {
        if (res.status == 200) {
            return res;
        } else if (res.status == 401) {
            MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定退出', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push('/login')
            })
        }
    }
})
//登录
export const login = (username, password) => axios.post('/admin/admin/login', qs.stringify({
    username,
    password
}))
//退出
export const loginOut = (admin_id) => axios.post('admin/admin/logout', qs.stringify({
    admin_id
}))
//重置密码
export const newPwd = (admin_id, new_password, new_respass) => axios.post('admin/admin/pas', qs.stringify({
    admin_id,
    new_password,
    new_respass
}))
//设置参数
export const parameter = (admin_id, address, email, phone, advantage, name, domain, contact, copyright) => axios.post('admin/admin/parameter', qs.stringify({
    admin_id,
    address,
    email,
    phone,
    advantage,
    name,
    domain,
    contact,
    copyright
}))
//获取参数
export const getParameter = (admin_id) => axios.get('admin/admin/parameter', {params:{
    admin_id
}})
//新增案例
export const instanceAdd = (admin_id, name, ios, intro, android, android_url, ios_url, navigation, one,two,three,four) => axios.post('admin/admin/instanceAdd', qs.stringify({
    admin_id,
    name,
    ios,
    intro,
    android,
    android_url,
    ios_url,
    navigation,
    one,
    two,three,four
}))
//获取案例
export const instanceList = (admin_id) => axios.post('admin/admin/instanceList',  qs.stringify({admin_id}))
//删除案例
export const instanceDel = (admin_id,id) => axios.post('admin/admin/instanceDel',  qs.stringify({admin_id,id}))
//获取团队
export const teamList = (admin_id) => axios.post('admin/admin/teamList',  qs.stringify({admin_id}))
//删除团队
export const teamDel = (admin_id,id) => axios.post('admin/admin/teamDel',  qs.stringify({admin_id,id}))
//新增团队
export const teamAdd = (admin_id,username,avatar,position) => axios.post('admin/admin/teamAdd',  qs.stringify({admin_id,username,avatar,position}))
//修改团队
export const teamEdit = (admin_id,username,avatar,position,id) => axios.post('admin/admin/teamEdit',  qs.stringify({admin_id,username,avatar,position,id}))
//图片上传
export const sends = (admin_id,logo,wechat,banner) => axios.post('admin/admin/sends',  qs.stringify({admin_id,logo,wechat,banner}))
//数据回显
export const getinfo = (admin_id) => axios.get('admin/admin/sends', {params:{
    admin_id
}})
